import { observable, action, runInAction } from 'mobx'
import Api from '@api/shou_xie/editStore'
import { message } from 'hljd'

class Store {
  @observable visible = false
  @action
  showExample = property_id => () => {
    this.visible = !this.visible

    if (this.visible) {
      this.getExample(property_id)
    }
  }

  @observable list = []
  @action
  getExample = async property_id => {
    let {
      data: { list },
      msg
    } = await Api.summaryExamples()
    if (msg == 'success') {
      runInAction(() => {
        this.list = (list || []).filter(item => item.property_id == property_id)
      })
    } else {
      return message.warning(msg)
    }
  }
}
export default new Store()
